export const GET_USER_LIST = 'GET_USER_LIST'
export const GET_ROLE_LIST = 'GET_ROLE_LIST'
